B2cApp.config(['$httpProvider', ($httpProvider)->
  $httpProvider.defaults.headers.common['X-CSRF-Token'] = document.getElementsByName('csrf-token')[0].content
  $httpProvider.defaults.headers.common['Accept'] = 'application/json'
])

B2cApp.controller 'LiseusesController', ['$scope', '$timeout', '$http', ($scope, $timeout, $http) ->
  
  $scope.init = () ->
    
    $scope.current_audio_index = 0
    $scope.current_play_status = "pause"
    liseuse_id = "demo"
    if $("#inspiration").length
      liseuse_id = "inspiration"
    else if $('#spitzberg').length
      liseuse_id = "spitzberg"
    else if $('#maude').length
      liseuse_id = "maude"
    else if $('#sacha_tome1').length
      liseuse_id = "sacha_tome1"
    else if $('#sacha_tome2').length
      liseuse_id = "sacha_tome2"
      
    window.addEventListener('hashchange', $scope.hashchangeFunction);
    document.addEventListener("keydown", $scope.processKeys, false);
    
    $http.get("/liseuses/load_pages?liseuse_id="+liseuse_id)
      .then (response) ->
        $("#liseuse_control_bottom").hide()
        $scope.urls = response.data.urls
        $scope.sounds = response.data.sounds
        #console.log($scope.urls)
        $scope.page_ratio = response.data.yearbook_ratio
    
        #Dimmension de l'interface
        $scope.screen_height = window.innerHeight
        $scope.screen_width = window.innerWidth
        $scope.page_height =  $scope.screen_height - 170
        $scope.page_width = $scope.page_height * $scope.page_ratio
        left_margin = 70
        $scope.adjust_top = 0
        if $scope.screen_height < 450
          $scope.adjust_top = -60
          $scope.page_height =  $scope.screen_height - 20
          $scope.page_width = $scope.page_height * $scope.page_ratio
          
          $scope.preview_page_height = $scope.page_height - 50
          $scope.preview_page_width = $scope.preview_page_height * $scope.page_ratio
          $scope.preview_small_page_height = 0
          $scope.preview_small_page_width = 0
          $("#preview_liseuse_panel").hide()
        else
          if $scope.screen_width < 550
            left_margin = 10
            $("#liseuse_control_bottom").show()
            $("#liseuse_control_right").hide()
          else
            $("#liseuse_control_bottom").hide()
          if (($scope.page_width + 70) * 2) > $scope.screen_width
            $scope.page_width = ($scope.screen_width / 2) - left_margin
            $scope.page_height =  $scope.page_width / $scope.page_ratio

            $("#preview_liseuse_panel").show()
            # Dimension lisesue
          $scope.preview_page_height = $scope.page_height - 50
          $scope.preview_page_width = $scope.preview_page_height * $scope.page_ratio
          $scope.preview_small_page_height = 120
          $scope.preview_small_page_width = $scope.preview_small_page_height * $scope.page_ratio
          
        $timeout( () ->
          if $scope.screen_height < 450
            $("#liseuse_control_bottom").hide()
          else
            if $scope.screen_width < 550
              $("#liseuse_control_bottom").show()
              $("#liseuse_control_right").hide()
            else
              $("#liseuse_control_bottom").hide()
          $scope.reorder_urls_for_liseuse ->
            $scope.create_liseuse()
        , 500)
        document.addEventListener("keydown", $scope.processKeys, false);

  $scope.processKeys = (evt) ->
    evt = evt || window.event;
    if $(document.activeElement).is( "input" ) == false
      #console.log(evt.keyCode)
      switch evt.keyCode
        when 37
          ### touche du gauche ###
          $scope.flipbook.turn('previous');
          #$scope.flipbook.turn('peel', 'br')
        when 39
          $scope.flipbook.turn('next');
  
  $scope.hashchangeFunction = (evt) ->
    urlParam = window.location.hash
    console.log("****")
    console.log(urlParam.replace('#', ''))
    $timeout( () ->
      if urlParam == "#convertio"
        window.open('https://convertio.co/fr/mp4-mp3/', '_blank');
      else if urlParam == "#audio_tool_set"
        window.open('https://audiotoolset.com/', '_blank');
      else if urlParam == "#audio_trimmer"
        window.open('https://audiotrimmer.com/', '_blank');
      else if urlParam == "#audio_joiner"
        window.open('https://audio-joiner.com/fr/', '_blank');
      else if urlParam == "#audio_converter"
        window.open('https://online-audio-converter.com/fr/', '_blank');
      else if urlParam == "#canva"
        window.open('https://www.canva.com/fr_fr/', '_blank');
      
      else if urlParam == "#free_make"
        window.open('https://www.freemake.com/fr/', '_blank');
      else if urlParam == "#online_audio_converter"
        window.open('https://online-audio-converter.com/fr/help/how_to_extract_sound_from_video', '_blank');
      else if urlParam == "#vlc"
        window.open('https://www.youtube.com/watch?v=aCfurgZ5ISU', '_blank');
      else if urlParam == "#fnac"
        window.open('https://numerisation.fnac.com/fr/accueil', '_blank');
      else if urlParam == "#photo_myne"
        window.open('https://photomyne.com/', '_blank');
      else if urlParam == "#premuim"
        window.open('https://akasha-editions.com/Sur-mesure-lancement', '_blank');
        
      $scope.flipbook.turn('page', (parseInt(urlParam.replace('#', '')) - 1))
      #$scope.apply_scope()
    , 500)
  
  $scope.run_sound = (index) ->
    if index != null
      $scope.current_audio_index = (index + 1)
      if $scope.current_audio != undefined
        $scope.stop_sound();
      $scope.current_audio = new Audio();
      $scope.current_audio.src = $scope.sounds[index]
      $scope.current_audio.load();
      $scope.play_sound()
      $scope.apply_scope()
  
  
  $scope.apply_scope = () ->
    try
      if !$scope.$$phase
        $scope.$apply()
    catch e
      #error
      
  $scope.play_sound = () ->
    if $scope.current_audio != undefined
      $scope.current_audio.play();
      $scope.current_play_status = "play"
      
  $scope.pause_sound = () ->
    if $scope.current_audio != undefined
      $scope.current_audio.pause();
      $scope.current_play_status = "pause"
      
  $scope.stop_sound = () ->
    if $scope.current_audio != undefined
      $scope.current_audio.pause();
      $scope.current_audio.currentTime = 0;
  
  $scope.get_sound = (page) ->
    sound_index = null
    $scope.second_sound = null
    if $("#inspiration").length
      if (page == 6 || page == 7)
        sound_index = 0
      else if (page == 12 || page == 13)
        sound_index = 1
      else if (page == 14 || page == 15)
        sound_index = 2
      else if (page == 16 || page == 17)
        sound_index = 3
      else if (page == 18 || page == 19)
        sound_index = 4
      else if (page == 24 || page == 25)
        sound_index = 5
      else if (page == 26 || page == 27)
        sound_index = 6
      else if (page == 28 || page == 29)
        sound_index = 7
      else if (page == 30 || page == 31)
        sound_index = 8
      else if (page == 32 || page == 33)
        sound_index = 9
      else if (page == 34 || page == 35)
        sound_index = 10
      else if (page == 36 || page == 37)
        sound_index = 11
      else if (page == 42 || page == 43)
        sound_index = 12
      else if (page == 44 || page == 45)
        sound_index = 13
      else if (page == 46 || page == 47)
        sound_index = 14
      else if (page == 48 || page == 49)
        sound_index = 15
      else if (page == 50 || page == 51)
        sound_index = 16
      else if (page == 52 || page == 53)
        sound_index = 17
      else if (page == 54 || page == 55)
        sound_index = 18
        
      else if (page == 62 || page == 63)
        sound_index = 19
      else if (page == 64 || page == 65)
        sound_index = 20
      else if (page == 66 || page == 67)
        sound_index = 21
      else if (page == 68 || page == 69)
        sound_index = 22
      else if (page == 70 || page == 71)
        sound_index = 23
      else if (page == 72 || page == 73)
        sound_index = 24
        
      else if (page == 78 || page == 79)
        sound_index = 25
      else if (page == 80 || page == 81)
        sound_index = 26
      else if (page == 82 || page == 83)
        sound_index = 27
      else if (page == 84 || page == 85)
        sound_index = 28
      else if (page == 86 || page == 87)
        sound_index = 29
        
      else if (page == 92 || page == 93)
        sound_index = 30
      else if (page == 94 || page == 95)
        sound_index = 31
      else if (page == 96 || page == 97)
        sound_index = 32
      else if (page == 98 || page == 99)
        sound_index = 33
      else if (page == 100 || page == 101)
        sound_index = 34
      else if (page == 102 || page == 103)
        sound_index = 35
        
      else if (page == 112 || page == 113)
        sound_index = 36
      else if (page == 114 || page == 115)
        sound_index = 37
      else if (page == 116 || page == 117)
        sound_index = 38
      else if (page == 118 || page == 119)
        sound_index = 39
    else if $("#spitzberg").length
      if (page == 6 || page == 7)
        sound_index = 0
      else if (page == 12 || page == 13)
        sound_index = 1
      else if (page == 20 || page == 21)
        sound_index = 2
      else if (page == 26 || page == 27)
        sound_index = 3
      else if (page == 38 || page == 39)
        sound_index = 4
      else if (page == 48 || page == 49)
        sound_index = 5
      else if (page == 60 || page == 61)
        sound_index = 6
      else if (page == 72 || page == 73)
        sound_index = 7
      else if (page == 76 || page == 77)
        sound_index = 8
      else if (page == 78 || page == 79)
        sound_index = 9
      else if (page == 84 || page == 85)
        sound_index = 10
      else if (page == 88 || page == 89)
        sound_index = 11
      else if (page == 92 || page == 93)
        sound_index = 12
      else if (page == 94 || page == 95)
        sound_index = 13
      else if (page == 96 || page == 97)
        sound_index = 14
      else if (page == 100 || page == 101)
        sound_index = 15
      else if (page == 106 || page == 107)
        sound_index = 16
      else if (page == 112 || page == 113)
        sound_index = 17
      else if (page == 122 || page == 123)
        sound_index = 18
      else if (page == 126 || page == 127)
        sound_index = 19
      else if (page == 134 || page == 135)
        sound_index = 20
      else if (page == 138 || page == 139)
        sound_index = 21
      else if (page == 152 || page == 153)
        sound_index = 22
      else if (page == 160 || page == 161)
        sound_index = 23
      else if (page == 164 || page == 165)
        sound_index = 24
      else if (page == 182 || page == 183)
        sound_index = 25
      else if (page == 192 || page == 193)
        sound_index = 26
      else if (page == 204 || page == 205)
        sound_index = 27
      else if (page == 208 || page == 209)
        sound_index = 28
      else if (page == 218 || page == 219)
        sound_index = 29
      else if (page == 220 || page == 221)
        sound_index = 30
      else if (page == 242 || page == 243)
        sound_index = 31
      else if (page == 244 || page == 245)
        sound_index = 32
    else if $("#maude").length
      if (page == 4 || page == 5)
        sound_index = 0
      else if (page == 6 || page == 7)
        sound_index = 1
      else if (page == 8 || page == 9)
        sound_index = 2
      else if (page == 10 || page == 11)
        sound_index = 3
      else if (page == 14 || page == 15)
        sound_index = 4
      else if (page == 16 || page == 17)
        sound_index = 5
      else if (page == 18 || page == 19)
        sound_index = 6
      else if (page == 24 || page == 25)
        sound_index = 7
      else if (page == 28 || page == 29)
        sound_index = 8
      else if (page == 30 || page == 31)
        sound_index = 9
      else if (page == 34 || page == 35)
        sound_index = 10
      else if (page == 36 || page == 37)
        sound_index = 11
      else if (page == 40 || page == 41)
        sound_index = 12
      else if (page == 44 || page == 45)
        sound_index = 13
      else if (page == 48 || page == 49)
        sound_index = 14
      else if (page == 50 || page == 51)
        sound_index = 15
      else if (page == 52 || page == 53)
        sound_index = 16
      else if (page == 64 || page == 65)
        sound_index = 17
      else if (page == 80 || page == 81)
        sound_index = 18
      else if (page == 88 || page == 89)
        sound_index = 19
      else if (page == 90 || page == 91)
        sound_index = 20
      else if (page == 98 || page == 99)
        sound_index = 21
      else if (page == 100 || page == 101)
        sound_index = 22
      else if (page == 102 || page == 103)
        sound_index = 23
      else if (page == 106 || page == 107)
        sound_index = 24
      else if (page == 108 || page == 109)
        sound_index = 25
      else if (page == 110 || page == 111)
        sound_index = 26
      else if (page == 116 || page == 117)
        sound_index = 27
      else if (page == 120 || page == 121)
        sound_index = 28
      else if (page == 122 || page == 123)
        sound_index = 29
      else if (page == 124 || page == 125)
        sound_index = 30
      else if (page == 128 || page == 129)
        sound_index = 31
      else if (page == 134 || page == 135)
        sound_index = 32
      else if (page == 142 || page == 143)
        sound_index = 33
      else if (page == 150 || page == 151)
        sound_index = 34
      else if (page == 152 || page == 153)
        sound_index = 35
      else if (page == 154 || page == 155)
        sound_index = 36
      else if (page == 166 || page == 167)
        sound_index = 37
      else if (page == 172 || page == 173)
        sound_index = 38
      else if (page == 176 || page == 177)
        sound_index = 39
      else if (page == 180 || page == 181)
        sound_index = 40
      else if (page == 182 || page == 183)
        sound_index = 41
      else if (page == 184 || page == 185)
        sound_index = 42
      else if (page == 186 || page == 186)
        sound_index = 43
      else if (page == 190 || page == 191)
        sound_index = 44
    
    else if $("#sacha_tome1").length
      if (page == 4 || page == 5)
        sound_index = 0
      else if (page == 10 || page == 11)
        sound_index = 1
      else if (page == 12 || page == 13)
        sound_index = 2
      else if (page == 14 || page == 15)
        sound_index = 3
      else if (page == 16 || page == 17)
        sound_index = 4
      else if (page == 18 || page == 19)
        sound_index = 5
      else if (page == 32 || page == 33)
        sound_index = 6
      else if (page == 36 || page == 37)
        sound_index = 7
      else if (page == 38 || page == 38)
        sound_index = 8
      else if (page == 40 || page == 41)
        sound_index = 9
      else if (page == 46 || page == 47)
        sound_index = 10
      else if (page == 48 || page == 49)
        sound_index = 11
      else if (page == 50 || page == 51)
        sound_index = 12
      else if (page == 52 || page == 53)
        sound_index = 13
      else if (page == 58 || page == 59)
        sound_index = 14
      else if (page == 60 || page == 61)
        sound_index = 15
      else if (page == 70 || page == 71)
        sound_index = 16
      else if (page == 72 || page == 73)
        sound_index = 17
      else if (page == 76 || page == 77)
        sound_index = 18
      else if (page == 80 || page == 81)
        sound_index = 19
      else if (page == 84 || page == 85)
        sound_index = 20
      else if (page == 86 || page == 87)
        sound_index = 21
      else if (page == 88 || page == 89)
        sound_index = 22
      else if (page == 90 || page == 91)
        sound_index = 23
      else if (page == 92 || page == 93)
        sound_index = 24
      else if (page == 94 || page == 95)
        sound_index = 25
      else if (page == 96 || page == 97)
        sound_index = 26
      else if (page == 98 || page == 99)
        sound_index = 27
      else if (page == 100 || page == 101)
        sound_index = 28
      else if (page == 118 || page == 119)
        sound_index = 29
      else if (page == 130 || page == 131)
        sound_index = 30
      else if (page == 132 || page == 133)
        sound_index = 31
      else if (page == 134 || page == 135)
        sound_index = 32
      else if (page == 136 || page == 137)
        sound_index = 33
      else if (page == 138 || page == 139)
        sound_index = 34
      else if (page == 140 || page == 141)
        sound_index = 35
      else if (page == 144 || page == 145)
        sound_index = 36
      else if (page == 146 || page == 147)
        sound_index = 37
      else if (page == 148 || page == 149)
        sound_index = 38
      else if (page == 150 || page == 151)
        sound_index = 39
      else if (page == 152 || page == 153)
        sound_index = 40
      else if (page == 154 || page == 155)
        sound_index = 41
      else if (page == 156 || page == 157)
        sound_index = 42
      else if (page == 158 || page == 159)
        sound_index = 43
      else if (page == 160 || page == 161)
        sound_index = 44
      else if (page == 164 || page == 165)
        sound_index = 45
      else if (page == 166 || page == 167)
        sound_index = 46
      else if (page == 168 || page == 169)
        sound_index = 47
      else if (page == 170 || page == 171)
        sound_index = 48
      else if (page == 172 || page == 173)
        sound_index = 49
      else if (page == 180 || page == 181)
        sound_index = 50
        $scope.second_sound = 51
      else if (page == 182 || page == 183)
        sound_index = 52
      else if (page == 184 || page == 185)
        sound_index = 53
      else if (page == 186 || page == 187)
        sound_index = 54
      else if (page == 188 || page == 189)
        sound_index = 55
      
        
        
        
        
    else if $("#sacha_tome2").length
      if (page == 8 || page == 9)
        sound_index = 0
      else if (page == 10 || page == 11)
        sound_index = 1
      else if (page == 12 || page == 13)
        sound_index = 2
      else if (page == 14 || page == 15)
        sound_index = 3
      else if (page == 16 || page == 17)
        sound_index = 4
      else if (page == 18 || page == 19)
        sound_index = 5
      else if (page == 20 || page == 21)
        sound_index = 6
      else if (page == 22 || page == 23)
        sound_index = 7
      else if (page == 24 || page == 25)
        sound_index = 8
      else if (page == 28 || page == 29)
        sound_index = 9
      else if (page == 36 || page == 37)
        sound_index = 10
      else if (page == 38 || page == 39)
        sound_index = 11
      else if (page == 40 || page == 41)
        sound_index = 12
      else if (page == 42 || page == 43)
        sound_index = 13
      else if (page == 44 || page == 45)
        sound_index = 14
      else if (page == 46 || page == 47)
        sound_index = 15
      else if (page == 50 || page == 51)
        sound_index = 16
      else if (page == 52 || page == 53)
        sound_index = 17
      else if (page == 54 || page == 55)
        sound_index = 18
      else if (page == 58 || page == 59)
        sound_index = 19
      else if (page == 62 || page == 63)
        sound_index = 20
      else if (page == 64 || page == 65)
        sound_index = 21
      else if (page == 66 || page == 67)
        sound_index = 22
      else if (page == 82 || page == 83)
        sound_index = 23
        $scope.second_sound = 24
      else if (page == 84 || page == 85)
        sound_index = 25
        $scope.second_sound = 26
      else if (page == 86 || page == 87)
        sound_index = 27
        $scope.second_sound = 28
      else if (page == 88 || page == 89)
        sound_index = 29
        $scope.second_sound = 30
      else if (page == 90 || page == 90)
        sound_index = 31
      else if (page == 92 || page == 93)
        sound_index = 32
      else if (page == 94 || page == 95)
        sound_index = 33
      else if (page == 96 || page == 97)
        sound_index = 34
      else if (page == 98 || page == 99)
        sound_index = 35
        $scope.second_sound = 36
      else if (page == 100 || page == 101)
        sound_index = 37
      else if (page == 102 || page == 103)
        sound_index = 38
      else if (page == 104 || page == 105)
        sound_index = 39
      else if (page == 106 || page == 107)
        sound_index = 40
        $scope.second_sound = 41
      else if (page == 108 || page == 109)
        sound_index = 42
        $scope.second_sound = 43
      else if (page == 110 || page == 111)
        sound_index = 44
      else if (page == 112 || page == 113)
        sound_index = 45
      else if (page == 114 || page == 115)
        sound_index = 46
      else if (page == 118 || page == 119)
        sound_index = 47
      else if (page == 120 || page == 121)
        sound_index = 48
      else if (page == 122 || page == 123)
        sound_index = 49
      else if (page == 124 || page == 125)
        sound_index = 50
      else if (page == 126 || page == 127)
        sound_index = 51
        $scope.second_sound = 52
      else if (page == 128 || page == 129)
        sound_index = 53
        $scope.second_sound = 54
      else if (page == 130 || page == 131)
        sound_index = 55
      else if (page == 132 || page == 133)
        sound_index = 56
      else if (page == 134 || page == 135)
        sound_index = 57
      else if (page == 136 || page == 137)
        sound_index = 58
      else if (page == 138 || page == 139)
        sound_index = 59
      else if (page == 140 || page == 141)
        sound_index = 60
      else if (page == 142 || page == 143)
        sound_index = 61
      else if (page == 144 || page == 145)
        sound_index = 62
      else if (page == 146 || page == 147)
        sound_index = 63
      else if (page == 148 || page == 149)
        sound_index = 64
      else if (page == 150 || page == 151)
        sound_index = 65
        $scope.second_sound = 66
      else if (page == 152 || page == 153)
        sound_index = 67
      else if (page == 154 || page == 155)
        sound_index = 68
      else if (page == 156 || page == 157)
        sound_index = 69
      else if (page == 158 || page == 159)
        sound_index = 70
      else if (page == 162 || page == 163)
        sound_index = 71
      else if (page == 164 || page == 165)
        sound_index = 72
      else if (page == 168 || page == 169)
        sound_index = 73
      else if (page == 174 || page == 175)
        sound_index = 74
      else if (page == 176 || page == 177)
        sound_index = 75
      else if (page == 178 || page == 179)
        sound_index = 76
        
        
        
        
    else
      if (page == 4 || page == 5)
        sound_index = 0
      else if (page == 6 || page == 7)
        sound_index = 1
      else if (page == 10 || page == 11)
        sound_index = 2
      else if (page == 12 || page == 13)
        sound_index = 3
      else if (page == 14 || page == 15)
        sound_index = 4
      else if (page == 16 || page == 17)
        sound_index = 5
      else if (page == 18 || page == 19)
        sound_index = 6
      else if (page == 22 || page == 23)
        sound_index = 7
      else if (page == 24 || page == 25)
        sound_index = 8
      else if (page == 28 || page == 29)
        sound_index = 9
      else if (page == 34 || page == 35)
        sound_index = 10
      else if (page == 38 || page == 39)
        sound_index = 11
      #else if (page == 44 || page == 45)
      #  sound_index = 12
      else if (page == 44 || page == 45)
        sound_index = 12
      else if (page == 46 || page == 47)
        sound_index = 13
      else if (page == 48 || page == 49)
        sound_index = 14
      else if (page == 50 || page == 51)
        sound_index = 15
      else if (page == 54 || page == 55)
        sound_index = 16
      else if (page == 58 || page == 59)
        sound_index = 17
      else if (page == 62 || page == 63)
        sound_index = 18
      else if (page == 64 || page == 65)
        sound_index = 19
        
      else if (page == 66 || page == 67)
        sound_index = 20
      else if (page == 68 || page == 69)
        sound_index = 21
      else if (page == 70 || page == 71)
        sound_index = 22
      else if (page == 72 || page == 73)
        sound_index = 23
      else if (page == 74 || page == 75)
        sound_index = 24
      else if (page == 76 || page == 77)
        sound_index = 25
      else if (page == 78 || page == 79)
        sound_index = 26
      else if (page == 80 || page == 81)
        sound_index = 27
      else if (page == 82 || page == 83)
        sound_index = 28
      else if (page == 84 || page == 85)
        sound_index = 29
      else if (page == 86 || page == 87)
        sound_index = 30
      else if (page == 88 || page == 89)
        sound_index = 31
      else if (page == 90 || page == 91)
        sound_index = 32
      else if (page == 92 || page == 93)
        sound_index = 33
      else if (page == 94 || page == 95)
        sound_index = 34
      else if (page == 98 || page == 99)
        sound_index = 35
        
      else if (page == 102 || page == 103)
        sound_index = 36
      else if (page == 104 || page == 105)
        sound_index = 37
      else if (page == 108 || page == 109)
        sound_index = 38
      else if (page == 112 || page == 113)
        sound_index = 39
      else if (page == 114 || page == 115)
        sound_index = 40
      else if (page == 118 || page == 119)
        sound_index = 41
      else if (page == 120 || page == 121)
        sound_index = 42
      else if (page == 126 || page == 127)
        sound_index = 43
      else if (page == 130 || page == 131)
        sound_index = 44
      else if (page == 136 || page == 137)
        sound_index = 45
      else if (page == 138 || page == 139)
        sound_index = 46
      else if (page == 146 || page == 147)
        sound_index = 47
        
      else if (page == 148 || page == 149)
        sound_index = 48
      else if (page == 150 || page == 151)
        sound_index = 49
      else if (page == 152 || page == 153)
        sound_index = 50
      else if (page == 154 || page == 155)
        sound_index = 51
      else if (page == 156 || page == 157)
        sound_index = 52
      else if (page == 158 || page == 159)
        sound_index = 53
      else if (page == 160 || page == 161)
        sound_index = 54
      else if (page == 162 || page == 163)
        sound_index = 55
      else if (page == 164 || page == 165)
        sound_index = 56
      else if (page == 174 || page == 175)
        sound_index = 57
    if sound_index == 0
      $('#info_turn_liseuse').hide()
    sound_index
      
  $scope.create_liseuse = () ->
    
    $scope.total_page = $scope.urls.length + 4
    #total_page = total_page - 1#TEMP POUR LA COVER
    flipbook = $('.sj-book');
    
    $('#slider-bar').show();
    
    $('#slider').slider
      min: 1
      max: ($scope.total_page - 2)
      start: (event, ui) ->
        #if !window._thumbPreview
        #  _thumbPreview = $('<div />', 'class': 'thumbnail').html('<div></div>')
        #  $scope.setPreview ui.value
        #  _thumbPreview.appendTo $(ui.handle)
        #else
        #  $scope.setPreview ui.value
        $scope.moveBar false
        return
      slide: (event, ui) ->
        #$scope.setPreview ui.value
        return
      stop: ->
        #if window._thumbPreview
        #  _thumbPreview.removeClass 'show'
        $('.sj-book').turn 'page', Math.max(1, $(this).slider('value') * 2 - 2)
        return
    
    
    #angular.forEach $scope.urls, (summary_bloc, index) ->
    #  
    #  console.log(summary_bloc.id)
    #  element = $("#preview_small_canvas_container_"+ summary_bloc.id)
    #  $(element).html(null)
    #  console.log($(element))
    #  #creation du canvas
    #  newCanvas = $(document.createElement('canvas'))
    #  newCanvas.attr('id', "preview_small_preview_page_canvas_" + $(element).attr('summary_bloc_id'))
    #  newCanvas.attr('summary_bloc_id', $(element).attr('summary_bloc_id'))
    #
    #  $(element).html(newCanvas)
    #  pre_view_page_canvas    = new fabric.Canvas($(newCanvas).attr('id'), {selection: false})
    #  pre_view_page_canvas.setWidth  $scope.preview_small_page_width
    #  pre_view_page_canvas.setHeight $scope.preview_small_page_height
    #  summary_bloc.changed = false
    #  if summary_bloc.objects_positions != null
    #    pre_view_page_canvas.loadFromPrintDimensionsJSON ($scope.print_page_height / $scope.preview_small_page_height), summary_bloc.objects_positions,  ->
    #    pre_view_page_canvas.on 'selection:created', () ->
    #      $scope.disable_section_object(pre_view_page_canvas)
    #    pre_view_page_canvas.on 'selection:updated', () ->
    #      $scope.disable_section_object(pre_view_page_canvas)
          
    # Flipbook
    $scope.flipbook = flipbook.turn(
      elevation: 50
      acceleration: true
      autoCenter: true
      gradients: true
      duration: 1000
      pages: $scope.total_page
      when:
        turning: (e, page, view) ->
          $scope.pause_sound()
          book = $(this)
          currentPage = book.turn('page')
          pages = book.turn('pages')
          if currentPage > 3 and currentPage < pages - 3
            if page == 1
              book.turn('page', 2).turn('stop').turn 'page', page
              e.preventDefault()
              return
            else if page == pages
              book.turn('page', pages - 1).turn('stop').turn 'page', page
              e.preventDefault()
              return
          else if page > 3 and page < pages - 3
            if currentPage == 1
              book.turn('page', 2).turn('stop').turn 'page', page
              e.preventDefault()
              return
            else if currentPage == pages
              book.turn('page', pages - 1).turn('stop').turn 'page', page
              e.preventDefault()
              return
          $scope.updateDepth book, page
          if page >= 2
            $('.sj-book .p2').addClass 'fixed'
          else
            $('.sj-book .p2').removeClass 'fixed'
          if page < book.turn('pages')
            $('.sj-book .p' + ($scope.total_page-1)).addClass 'fixed'
          else
            $('.sj-book .p'+($scope.total_page-1)).removeClass 'fixed'
          #Hash.go('page/'+page).update();
          
          #if (page==1 || page==pages)
          #  $('.sample-docs .tabs').hide();
            
          return
        turned: (e, page, view) ->
          book = $(this)
          if page == 2 or page == 3
            book.turn 'peel', 'br'
          $scope.updateDepth book
          $('#slider').slider 'value', $scope.getViewNumber(book, page)
          book.turn 'center'
          sound = $scope.get_sound(page)
          $scope.run_sound(sound)
          #if (page!=1 && page!=book.turn('pages'))
          #  $('.sample-docs .tabs').fadeIn(500);
          #else
          #  $('.sample-docs .tabs').hide();
          $timeout( () ->
            $("#toolbar").remove()
          , 500)
          return
        start: (e, pageObj) ->
          $scope.moveBar true
          return
        end: (e, pageObj) ->
          book = $(this)
          $scope.updateDepth book
          setTimeout (->
            $('#slider').slider 'value', $scope.getViewNumber(book)
            return
          ), 1
          $scope.moveBar false
          return
        missing: (e, pages) ->
          book = $(this)
          i = 0
          
          while i < pages.length
            $scope.addPage(pages[i], $(this), i)
    
            i++
          return
    )#.turn('page', 2)
    
    #$timeout( () ->
    #  $scope.flipbook.turn('page', 2)
    #, 1000)
    
    $('#slider').slider 'option', 'max', $scope.numberOfViews(flipbook)
    flipbook.addClass 'animated'        

    

  $scope.get_page_by_index = (i, left_page) ->
    result = 0
    if i == 0
      result = 0
    else
      if left_page
        result = i * 2 -1
      else
        result = i * 2
    #
    if result  > $scope.urls.length - 1
      result = $scope.urls.length - 1
    result
    
  $scope.reorder_urls_for_liseuse= (callback) ->
    $scope.summary_bloc_ids_for_cdf = []
    i = 0
    loop
      if i == 0 || i == ($scope.urls.length / 2)
        page_id = $scope.get_page_by_index(i, true)
        $scope.summary_bloc_ids_for_cdf.push([{url: $scope.urls[page_id], page_id: page_id}])
      else
        left_page_id = $scope.get_page_by_index(i, true)
        right_page_id = $scope.get_page_by_index(i, false)
        $scope.summary_bloc_ids_for_cdf.push([{url: $scope.urls[left_page_id], page_id: left_page_id}, {url: $scope.urls[right_page_id], page_id: right_page_id}])
      i = i + 1
      unless i < ($scope.urls.length / 2 + 1)
        break
    $timeout( () ->
      callback()
    , 500)
    
  $scope.turn_to_page = (page_id) ->
    $scope.flipbook.turn('page', page_id + 2)
  ### Steve jobs' book ###
  $scope.setPreview = () ->
    
  $scope.addPage = (page, book, i) ->
    id = undefined
    pages = book.turn('pages')
    if !book.turn('hasPage', page)
      #summary_bloc = $scope.summary_blocs[page - 3]
      summary_bloc = $scope.urls[page - 3]
      #angular.forEach $scope.summary_blocs, (summary_bloc, index) ->
      element = $('<div />',
            'class': 'own-size preview_page_liseuse'
            css:
              width: ($scope.preview_page_width)
              height: ($scope.preview_page_height))#.html(page)
      
      element.attr('id', "preview_yearbook_page_container_"+ page)
      
      
      if summary_bloc.indexOf(".pdf") != -1
        #<embed src="pdfFiles/interfaces.pdf" width="600" height="500" alt="pdf" pluginspage="http://www.adobe.com/products/acrobat/readstep2.html">
        img = $('<object />');
        img.css({width: 'calc(100% + 6px)', height: '100%', 'margin-top': '-2px', 'margin-left': '-3px'});
        
        img.attr("data", summary_bloc + "#toolbar=0&navpanes=0&scrollbar=0&statusbar=0&messages=0&scrollbar=0")
        img.attr("type", "application/pdf")

        #pdf_data = $('<a />')
        #pdf_data.attr("href", summary_bloc)
        #$(img).html(pdf_data)
      else
        img = $('<img />');
        img.attr("src", summary_bloc)
        img.css({width: '100%'});
      $(element).html(img)
      
      if book.turn('addPage', element, page)
        console.log('ok')
        #loadPage page
    return
    
  $scope.updateDepth = (book, newPage) ->
    page = book.turn('page')
    pages = book.turn('pages')
    depthWidth = 16 * Math.min(1, page * 2 / pages)
    newPage = newPage or page
    if newPage > 3
      $('.sj-book .p2 .depth').css
        width: depthWidth
        left: 20 - depthWidth
    else
      $('.sj-book .p2 .depth').css width: 0
    depthWidth = 16 * Math.min(1, (pages - page) * 2 / pages)
    if newPage < pages - 3
      $('.sj-book .p' + ($scope.total_page - 1) + ' .depth').css
        width: depthWidth
        right: 20 - depthWidth
    else
      $('.sj-book .p'+($scope.total_page - 1)+' .depth').css width: 0
    return

  $scope.numberOfViews = (book) ->
    book.turn('pages') / 2 + 1

  $scope.getViewNumber = (book, page) ->
    parseInt (page or book.turn('page')) / 2 + 1, 10

  $scope.zoomHandle = (e) ->
    if $('.sj-book').data().zoomIn
      zoomOut()
    else if e.target and $(e.target).hasClass('zoom-this')
      zoomThis $(e.target)
    return

  $scope.moveBar = (yese) ->
    index = yese ? -1 : 10000
    #if Modernizr and Modernizr.csstransforms
    $('#slider .ui-slider-handle').css('z-index', index)#: if yese then -1 else 10000
    #return

  $scope.setPreview2 = (view) ->
    previewWidth = 115
    previewHeight = 73
    previewSrc = 'pages/preview.jpg'
    preview = $(_thumbPreview.children(':first'))
    numPages = if view == 1 or view == $('#slider').slider('option', 'max') then 1 else 2
    width = if numPages == 1 then previewWidth / 2 else previewWidth
    _thumbPreview.addClass('no-transition').css
      width: width + 15
      height: previewHeight + 15
      top: -previewHeight - 30
      left: ($($('#slider').children(':first')).width() - width - 15) / 2
    preview.css
      width: width
      height: previewHeight
    if preview.css('background-image') == '' or preview.css('background-image') == 'none'
      preview.css backgroundImage: 'url(' + previewSrc + ')'
      setTimeout (->
        _thumbPreview.removeClass 'no-transition'
        return
      ), 0
    preview.css backgroundPosition: '0px -' + (view - 1) * previewHeight + 'px'
    return



]
